import React from "react";
import UseContext from "hooks/useContext";
import { ExclamationCircle } from "assets/icons";
import { getCountText } from "pages/profil/perimeters/perimeterText";

// Members left without any perimeter see every mission again; `message`
// replaces that default wording.
const PerimeterAccessAlert = ({ count, message }) => {
    const { language } = UseContext();

    return (
        <div
            role="alert"
            className="flex items-start gap-3 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700"
        >
            <span aria-hidden="true" className="mt-0.5 shrink-0">
                <ExclamationCircle wh={20} color="#DC2626" />
            </span>
            <p>
                {message ??
                    getCountText(
                        language,
                        "perimeters.alert.membersAccess",
                        count
                    )}
            </p>
        </div>
    );
};

export default PerimeterAccessAlert;
